<script type="text/javascript">
  // Homie site review
  export default {
    props: ['website'],
    data() {
      return {
        title: 'Homie',
        url: 'https://homie.com',
        updated: '9/18/2023',

        pages: [
          // ========== START OF PAGE ==========
          {
            title: 'Home',
            main: 1,
            url: `https://homie.com`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Real Estate Agents in UT, AZ, NV, CO, ID - Homie`,
            meta_desc: `If you're looking to buy or sell a home, our experienced agents can help you from start to finish. You'll save thousands in real estate commissions! Click here to learn more.`,
            h1: [
              `Save More of Your Equity.`,
              `Buy Your Next Home Like a Boss.`,
              `Bundle and Save $20,000.`,
              `Thanks!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              `$100,003,250`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Buy',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Why buy with Homie?',
                main: 1,
                url: `https://homie.com/buy`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Homes for Sale UT, AZ, NV, CO, ID - Homie`,
                meta_desc: `Whether you're buying your first home your fifth home, Homie can save you thousands in real estate commissions. Click here to learn more.`,
                h1: [
                  `Get the home you really want.`,
                  `Get in Touch`,
                  `Thanks!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Search homes',
                main: 1,
                url: `Not defined but URL is: https://www.homie.com/search`,
                positives: [
                  ``,
                ],
                negatives: [
                  `Missing meta description`,
                  `No primary H1 tag. Home prices are listed as the H1 headers.`,
                  `Navigation bar changes on this page. Buy and Sell are swapped.`,
                  'Canonical URL is not defined.',
                ],
                meta_title: `Homes for Sale & Real Estate Listings - Homie`,
                meta_desc: ``,
                h1: [
                  `475 H1 headers which are the prices of the homes listed.`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: '50/50 commission split (Links to Pricing page)',
                main: 1,
              },
              // ========== START OF PAGE ==========
              {
                title: 'How much home can I afford?',
                main: 1,
                url: `https://www.homie.com/how-much-home-can-you-afford`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Home Affordability Calculator - Homie`,
                meta_desc: `Wondering how much home is in your budget? Calculate your price range here. Click to get started.`,
                h1: [
                  `How Much Home Can You Afford?`,
                  `A Homie Loan Officer will be in touch with you!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  `$245,441`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Homeowners insurance',
                main: 1,
                url: `https://www.homieinsure.com`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Insurance in UT, AZ, NV, ID, and CO - Homie Insurance`,
                meta_desc: `From home insurance to the catch-all umbrella insurance, Homie Insurance wants to help you find the right coverage for the right price. Click here to learn more.`,
                h1: [
                  `Insurance That Makes Sense`,
                  `Homie Insurance Quote`,
                  `Your insurance quote is on it's way!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Home & moving services (Links to Services page)',
                main: 1,
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Sell',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Why sell with Homie?',
                main: 1,
                url: `https://www.homie.com/sell`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Sell Your Home UT, NV, AZ, CO, ID - Homie`,
                meta_desc: `Tired of paying high real estate commissions? Get expert service at a low fee with Homie. Click here to learn more.`,
                h1: [
                  `You save more. We take less. Keep your equity.`,
                  `Get in Touch`,
                  `Thanks!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  `More Money in Your Pocket`,
                  `$11,500`,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'List your home (Login required)',
                main: 1,
                url: `https://www.homie.com/selling/listing-start`,
                positives: [
                  ``,
                ],
                negatives: [
                  `Page immediately prompts for login.`,
                ],
                meta_title: ``,
                meta_desc: ``,
                h1: [
                  ``,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Pricing',
                main: 1,
                url: `https://www.homie.com/pricing`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `How much does it cost to sell with Homie? - Homie`,
                meta_desc: `Homie’s mission is to save home buyers and sellers thousands in excessive fees and commissions. Average Homie customers save $10,000. Check out how much you can save by choosing Homie.`,
                h1: [
                  `Say Goodbye to High Commissions`,
                  `Get in Touch`,
                  `Thanks!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'What is my home worth?',
                main: 1,
                url: `https://www.homie.com/home-value-report`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Free Home Value Report - Homie`,
                meta_desc: `Wondering how much your home is worth? Get your free value report now! Click here.`,
                h1: [
                  `What's Your Home Worth?`,
                  `We're starting your report!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Seller toolkit',
                main: 1,
                url: `https://www.homie.com/how-to-sell-your-home`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `How to Sell Your Home: Tool Kit - Homie`,
                meta_desc: `Ready to list your home? Get our free guides on listing, selling, and more! Click here to download.`,
                h1: [
                  `The Smart Home Seller's Guide`,
                  `Download the free toolkit`,
                  `Your Seller Toolkit is on it's way!`,
                  `Sorry, there was an issue submitting your information.`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Home services (Links to Services page)',
                main: 1,
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'Loans',
            main: 1,
            url: `https://www.homieloans.com/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Low rates. Low fees. Happy customers. - Homie Loans ™`,
            meta_desc: `We love helping you save money. Whether you’re using Homie to buy or sell or you just want a great rate, we’ve got your back. Click here to learn more.`,
            h1: [
              `Home is Possible with Homie Loans`,
              `Refinance With Homie Loans™`,
              `Buy Your Home With Homie Loans™`,
              `Thank You!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Insurance',
            main: 1,
            url: `https://www.homieinsure.com`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Insurance in UT, AZ, NV, ID, and CO - Homie Insurance`,
            meta_desc: `From home insurance to the catch-all umbrella insurance, Homie Insurance wants to help you find the right coverage for the right price. Click here to learn more.`,
            h1: [
              `Insurance That Makes Sense`,
              `Homie Insurance Quote`,
              `Your insurance quote is on it's way!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Title',
            main: 1,
            url: `https://www.homietitleagency.com/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Title Company - Homie Title`,
            meta_desc: ``,
            h1: [
              `Now a simpler way to close`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Services',
            main: 1,
            url: `https://www.homie.com/marketplace`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Service Provider Marketplace - Homie`,
            meta_desc: `Service Provider Marketplace`,
            h1: [
              ``,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Log In',
            main: 1,
            url: `https://auth.homie.com/Account/Login`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Homie Identity`,
            meta_desc: ``,
            h1: [
              ``,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Sign Up (Links to Log In page)',
            main: 1,
          },
          // ========== START OF PAGE ==========
          {
            title: 'Reviews',
            main: 0,
            url: `https://www.homie.com/reviews`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Homie Reviews and Testimonials - Homie`,
            meta_desc: ``,
            h1: [
              `We've Helped Thousands of Customers, Just Like You`,
              `Get in Touch`,
              `Thanks!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Homie Cash',
            main: 0,
            url: `https://www.homie.com/cash`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Beat the Competition with Homie Cash - Homie`,
            meta_desc: `Worried about landing your dream home? Fear not! Jump the line and dramatically increase your odds of winning with an all-cash offer from Homie Cash. Right this way to get approved in 48 hours or less.`,
            h1: [
              `Homie Cash. Offer Accepted.`,
              `Thank You!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              `Homie Cash. Offer Accepted.`,
              `How It All Works`,
              `Homie Cash Stacks Up`,
              `FAQs`,
              `Step Up Your Offer Game With Homie Cash`,
              `Get Pre-Approved for Homie Cash`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Buy Today. Sell Tomorrow.',
            main: 0,
            url: `https://www.homie.com/buy-before-you-sell`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Buy before you sell - Homie`,
            meta_desc: `Buy and move into your new home using, then list your home and sell for top dollar. The best of both worlds.`,
            h1: [
              `Buy Today. Sell Tomorrow. Rest Easy.`,
              `Get in Touch`,
              `Thanks!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Talk to an Agent',
            main: 0,
            url: `https://www.homie.com/talk-to-a-homie-agent`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Talk to a Real Estate Agent - Homie`,
            meta_desc: `Whether you're thinking about buying or selling, talking to a licensed real estate agent is the first step. Experienced Homie agents are standing by.`,
            h1: [
              `Talk to an Expert Local Homie Agent`,
              `Get in Touch`,
              `Thanks!`,
              `Sorry, there was an issue submitting your information.`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'About Us',
            main: 0,
            url: `https://www.homie.com/about`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Our Story - Homie`,
            meta_desc: `Our Story`,
            h1: [
              ``,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Press',
            main: 0,
            url: `https://www.homie.com/media`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Homie Media Coverage - Homie`,
            meta_desc: ``,
            h1: [
              `Media Coverage`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Careers',
            main: 0,
            url: `https://www.homie.com/careers`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Careers - Homie`,
            meta_desc: `Be part of the team that’s disrupting the real estate industry. Click here for careers openings, to learn about the Homie culture, and more. Join teal today.`,
            h1: [
              `We're Changing Real Estate, For Good`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Homie Blog',
            main: 0,
            url: `https://www.homie.com/blog`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `All You Need to Know About Buying or Selling a Home | Homie`,
            meta_desc: `If you're buying or selling a home, you deserve transparency. Click here to learn more about the processes.`,
            h1: [
              `Homie Blog`,
            ],
            h2: [
              `How Much Does Homie Cost?`,
              `How an Idaho Couple Used Homie's Buy Before You Sell Program to Get Ahead in a Competitive Housing Market`,
              `Many homeowners overvalue their home. Here's why.`,
              `Selling and Buying a Home at the Same Time`,
              `Top 10 Home Builders in Utah`,
              `Choose Your Home Adventure`,
              `QUIZ: Are You Ready to Buy a House?`,
              `How to Deal With the Stress of Buying a House`,
              `6 Tips to Make Your Summer Move Easier`,
              `Building Wealth Through Real Estate`,
              `Posts navigation`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'FAQs',
            main: 0,
            url: `https://www.homie.com/faqs`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Frequently Asked Questions - Homie`,
            meta_desc: ``,
            h1: [
              `Frequently Asked Questions`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Contact Us',
            main: 0,
            url: `https://www.homie.com/contact`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Get in touch with us - Homie`,
            meta_desc: ``,
            h1: [
              `Get in Touch`,
              ``,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Install App',
            main: 0,
            url: `https://www.homie.com/app/install`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Homes for Sale & Real Estate Listings - Homie`,
            meta_desc: `Homes for Sale & Real Estate Listings`,
            h1: [
              `Installation Instructions`,
            ],
            h2: [
              `Chrome (Desktop)`,
              `Chrome (Android)`,
              `Firefox`,
              `Edge`,
              `Safari (iOS)`,
              `Safari (macOS)`,
              `Samsung Internet (Android)`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Legal Terms & Policies',
            main: 0,
            url: `https://www.homie.com/legal`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Legal - Homie`,
            meta_desc: ``,
            h1: [
              `Homie Legal Terms and Policies`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Cookie Notice',
            main: 0,
            url: `https://www.homie.com/cookie-notice`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Cookie Notice - Homie`,
            meta_desc: ``,
            h1: [
              `Cookie Notice`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Privacy Policy',
            main: 0,
            url: `https://www.homie.com/privacy`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Privacy Policy - Homie`,
            meta_desc: ``,
            h1: [
              `Homie Privacy Policy`,
            ],
            h2: [
              `Personal Information Collected`,
              `Cookies and Similar Technologies`,
              `Usage of Personal Information`,
              `Disclosure of Personal Information`,
              `Real Estate Information`,
              `Email Communications`,
              `Third-Party Websites`,
              `Storage, Security and Retention of Information`,
              `Children's Privacy`,
              `Your Privacy Rights`,
              `Changes to this Privacy Policy`,
              `Contacting Homie`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Service Terms',
            main: 0,
            url: `https://www.homie.com/service-terms`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Service Terms - Homie`,
            meta_desc: ``,
            h1: [
              `Homie Service Terms`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'Terms & Conditions',
            main: 0,
            url: `https://www.homie.com/terms`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Terms and Conditions - Homie`,
            meta_desc: ``,
            h1: [
              `Homie's General Terms and Conditions`,
            ],
            h2: [
              ``,
            ]
          },
        ],

      }
    },
    computed: {
      compPages: function() {
        var output = [];
        for(var i in this.pages) {
          var temp = JSON.parse(JSON.stringify(this.pages[i]));
          if(temp['children']) { delete temp['children']; }
          output.push(temp);
          if(this.pages[i]['children']) {
            for(var j in this.pages[i]['children']) {
              var temp = JSON.parse(JSON.stringify(this.pages[i]['children'][j]));
              if(temp['children']) { delete temp['children']; }
              output.push(temp);
            }
          }
        }
        return output;
      },
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} navigation</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <h4 class="_underline">Site info</h4>
            <div class="mb-5">
              <div class=""><strong>Company :</strong> {{title}}</div>
              <div class=""><strong>URL :</strong> {{url}}</div>
              <div class=""><strong>Last updated :</strong> {{updated}}</div>

            </div>
            <h4 class="_underline">Main navigation</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="item['main']">
                <div class="font-weight-bolder">{{item['title']}}</div>
                <ul class="pl-5 m-0">
                  <li v-for="(sub1, sub1_i) in item['children']" :key="sub1_i">
                    {{sub1['title']}}
                    <ul class="pl-5 m-0">
                      <li v-for="(sub2, sub2_i) in sub1['children']" :key="sub2_i">
                        {{sub2['title']}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
            <h4 class="mt-5 _underline">Additional pages</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="!item['main']">{{item['title']}}</li>
            </ul>
          </div>



        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} page content</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s website content and SEO basics. Scroll through the table vertically and horizontally with the mouse wheel.</p>
          </div>

          <div class="table-responsive">
            <table class="table table-small table-bordered-right table-hover mb-0 text-nowrap border border-light">
              <thead class="bg-lighten-success">
                <tr>
                  <th class="font-weight-bold">Menu item</th>
                  <th class="font-weight-bold">URL</th>
                  <th class="font-weight-bold">Positives</th>
                  <th class="font-weight-bold">Negatives</th>
                  <th class="font-weight-bold">Meta title</th>
                  <th class="font-weight-bold">Meta description</th>
                  <th class="font-weight-bold">H1's</th>
                  <th class="font-weight-bold">H2's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_i) in compPages" :key="item_i">
                  <td class="bg-light font-weight-bold">{{item['title']}}</td>
                  <td>{{item['url']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['positives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['negatives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>{{item['meta_title']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">{{item['meta_desc']}}</td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h1']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h2']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
